import React from "react";
import { FiPlus } from "react-icons/fi";

// Type-safe icon wrapper
const PlusIcon = FiPlus as React.FC<React.SVGProps<SVGSVGElement>>;

interface ContactTypeCount {
  type: string;
  count: number;
}

interface RecipientTabsProps {
  activeTab: string;
  contactTypes: ContactTypeCount[];
  totalCount: number;
  onTabChange: (tab: string) => void;
  onAddContactClick: () => void;
}

/**
 * RecipientTabs - Tab navigation for filtering contacts by type
 */
const RecipientTabs: React.FC<RecipientTabsProps> = ({
  activeTab,
  contactTypes,
  totalCount,
  onTabChange,
  onAddContactClick,
}) => {
  return (
    <div className="su-recipients-tabs">
      <div className="su-recipients-tabs-list">
        {/* All Contacts Tab */}
        <button
          className={`su-recipients-tab ${activeTab === "all" ? "active" : ""}`}
          onClick={() => onTabChange("all")}
        >
          All Contacts ({totalCount})
        </button>

        {/* Dynamic Type Tabs - only show types with contacts */}
        {contactTypes
          .filter((t) => t.count > 0)
          .map(({ type, count }) => (
            <button
              key={type}
              className={`su-recipients-tab ${activeTab === type ? "active" : ""}`}
              onClick={() => onTabChange(type)}
            >
              {type.charAt(0) + type.slice(1).toLowerCase()} ({count})
            </button>
          ))}
      </div>

      {/* Add Contacts Button */}
      <button
        className="su-recipients-add-btn"
        onClick={onAddContactClick}
      >
        <PlusIcon className="w-4 h-4" />
        <span>Add Contacts</span>
      </button>
    </div>
  );
};

export default RecipientTabs;


